import { Injectable, inject } from '@angular/core';

import { AppConstant } from '../app.constant';
import { ChannelAccessService } from '../appServices/channel-access.service';
import { MentoringEvents } from './events';
import { DataCacheService } from './data-cache.service';
import { DraftStore } from '../stores/draft.store';
import { MentorMatchingStore } from '../stores/mentor-matching.store';
import { MentorHubApiService } from '../pages/mentor-hub/services/mentor-hub-api.service';
import { GamificationApiService } from '../pages/gamification/services/gamification-api.service';
import { NextBestActionService } from '../pages/mentor-hub/services/next-best-action.service';

/**
 * Ensures every logout path (manual /signout, idle auto-logout, 401 clear)
 * drops user-scoped in-memory state. Listens to MentoringEvents.sessionCleared
 * which UtilityHelper.clear() always emits.
 */
@Injectable({ providedIn: 'root' })
export class SessionCleanupService {
    private readonly mentoringEvents = inject(MentoringEvents);
    private readonly channelAccess = inject(ChannelAccessService);
    private readonly dataCache = inject(DataCacheService);
    private readonly mentorHubApi = inject(MentorHubApiService);
    private readonly gamificationApi = inject(GamificationApiService);
    private readonly draftStore = inject(DraftStore);
    private readonly mentorMatching = inject(MentorMatchingStore);
    private readonly nextBestAction = inject(NextBestActionService);

    constructor() {
        this.mentoringEvents.getSessionCleared().subscribe(() => this.clearUserSession());
    }

    /** Full wipe of caches / stores that survive cookie deleteAll. */
    clearUserSession(): void {
        this.channelAccess.clearCache();
        this.dataCache.clear();
        this.mentorHubApi.clearProjectDetailsCache();
        this.gamificationApi.clearNextStepsCaches();
        this.draftStore.clearAll();
        this.mentorMatching.resetMatchState();
        this.nextBestAction.setNextBestAction(null);

        // Re-assert sign-out flag if cookies/sessionStorage were wiped mid-clear.
        if (AppConstant.isSignOutInProgress()) {
            AppConstant.markSignOutInProgress();
        }
    }
}
